import { BRIEF_CONFIG_QUERY_KEY } from "@entities/brief/lib/constants";
import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { ALTERATIONS_LIST_QUERY_KEY } from "../constants";
import { FinanceApprovalService } from "../services/FinanceApprovalService";

export default function useApproveAlteration (briefId: string) {
    const {
        mutate: approveAlteration,
        isLoading: isApproveAlterationLoading,
        isSuccess: isApproveAlterationSuccess,
        error: approveAlterationError
    } = useMutation({
        mutationFn: async (alterationId: string) => FinanceApprovalService.approveAlteration(alterationId).catch(async (err) => {
            const responseBody = await err.response.json();
            ToastService.error(responseBody.msg);
            throw err;
        }),
        options: {
            skipInvalidation: true
        },
        onSuccess: (c) => {
            c.invalidateQueries({
                queryKey: [...ALTERATIONS_LIST_QUERY_KEY]
            });
            c.invalidateQueries({
                queryKey: BRIEF_CONFIG_QUERY_KEY(briefId)
            })
        }
    });
    return {
        approveAlteration,
        isApproveAlterationLoading,
        isApproveAlterationSuccess,
        approveAlterationError
    };
}